import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from '../internal_transfer/style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';

export default function ReturnOrderModal({ show, handleClose, onSubmit }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const defaultReasons = [
        { label: 'Defective / Damaged', value: 'Defective / Damaged' },
        { label: 'Wrong Item Shipped', value: 'Wrong Item Shipped' },
        { label: 'Customer Changed Mind', value: 'Customer Changed Mind' },
        { label: 'Not as Described', value: 'Not as Described' },
        { label: 'Others', value: 'Others' }
    ];

    const ReturnOrderVS = Yup.object().shape({
        reason: Yup.string().required('Reason is required'),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            reason: '',
        },
        validationSchema: ReturnOrderVS,
        onSubmit: (values) => {
            onSubmit(values);
        }
    });

    const isDark = theme?.toLowerCase() === 'dark';

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: '8px',
            border: state.isFocused ? '1px solid #4a86f7' : '1px solid #c9d1e1',
            boxShadow: state.isFocused ? '0 0 0 1px #4a86f7' : 'none',
            '&:hover': { border: '1px solid #4a86f7' },
            padding: '2px 4px',
            minHeight: '45px',
            backgroundColor: isDark ? '#262c48' : '#fff',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
        }),
        placeholder: (provided) => ({ ...provided, color: '#a8a8a8', fontSize: '14px' }),
        singleValue: (provided) => ({ ...provided, color: isDark ? '#fff' : '#000' }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDark ? '#262c48' : '#fff',
            borderRadius: '8px',
            overflow: 'hidden',
            zIndex: 9999,
            border: isDark ? '1px solid #353f5f' : '1px solid #c9d1e1',
            boxShadow: '0 4px 11px rgba(0, 0, 0, 0.15)',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#4a86f7' : state.isFocused ? (isDark ? '#353f5f' : '#e2ecff') : 'transparent',
            color: state.isSelected ? '#fff' : (isDark ? '#fff' : '#000'),
            cursor: 'pointer',
            padding: '10px 15px',
        }),
        input: (provided) => ({ ...provided, color: isDark ? '#fff' : '#000' }),
    };

    const { handleSubmit, values, touched, errors, setFieldValue } = formik;

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={'Return Reason'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    <div className={styles.flexex}>
                        <div className="w-100">
                            <div className="mb-3">
                                <label className={styles.CustomLabelStyle}>Reason for Return *</label>
                                <Select
                                    options={defaultReasons}
                                    styles={customSelectStyles}
                                    placeholder="Select Reason..."
                                    onChange={(selected) => setFieldValue('reason', selected.value)}
                                    value={defaultReasons.find(opt => opt.value === values.reason)}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />
                                {errors.reason && touched.reason && (
                                    <div className="text-danger small mt-1">{errors.reason}</div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton text={'Submit Return'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
